import script from './picker.vue_vue_type_script_lang.mjs';
export { default } from './picker.vue_vue_type_script_lang.mjs';
import { render } from './picker.vue_vue_type_template_id_1d54be91_lang.mjs';

script.render = render;
script.__file = "packages/components/time-picker/src/common/picker.vue";
//# sourceMappingURL=picker.mjs.map
